import { createApp } from 'vue'
import App from './App.vue'

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

import router from './router'
import store from './store/index'
//window.$ = window.jQuery = require('jquery');

const app = createApp(App);

app.use(VueToast, {
  position: "top-right",
  duration: 3000
})
app.use(router)
app.use(store)

app.mount('#app')


/*
import { createApp } from 'vue'
import App from './App.vue'


import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";


import router from './router'
import store from './store/index'
window.$ = window.jQuery = require('jquery');


const app = createApp(App);

app.use(VueToast);
app.use(VueToast, {
  position: "top-right",
  duration: 3000
});

import { useToast } from "vue-toast-notification";
const toast = useToast();

app.config.globalProperties.$toast = toast;



app.use(router)
app.use(store)
app.mount('#app')
*/
